module.exports = __webpack_public_path__ + "static/img/fullscreen-image_our-services.a0d92fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/fullscreen-image_our-services.png
// module id = Zpu4
// module chunks = 0